export default {
  "content": "<g clip-path=\"url(#clip0_316_15596)\"><path d=\"M11.945 2.116l-.642-.217c-.015-.006-.029-.015-.045-.02L9.34 1.217c-.025-.008-.05-.008-.075-.013l-.17-.058a1.62 1.62 0 00-.842-.013l-3.833.98c-.108-.028-.235-.055-.375-.102l-1.538-.517c-.006 0-.011 0-.017-.004l-.948-.32a.758.758 0 00-1 .718v8.278a.758.758 0 00.514.718l.423.144c.02.008.04.02.062.027l1.903.665.03.01c.037.007.076.013.114.016l.318.108c.274.08.565.084.841.014l3.9-.982 1.468.493 1.345.452a.758.758 0 00.999-.719V2.833a.759.759 0 00-.514-.717zm-7.07.985l3.25-.819v7.617l-3.25.819V3.1z\" fill=\"#717684\"/></g><defs><clipPath id=\"clip0_316_15596\"><path fill=\"#fff\" d=\"M0 0h13v13H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "13",
    "height": "13",
    "viewBox": "0 0 13 13",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};